import axios from '@/lib/axios';
import { LostNonWarrantyRequestParams } from '../types';

const createLostNonWarranty = (data: LostNonWarrantyRequestParams) => {
  return axios.post(`/facility/flat_rates/lost_non_warranty`, data);
}

export default createLostNonWarranty;